/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ sida',
  jump_to: 'GÃ¥ till',
  jump_to_confirm: 'bekrÃ¤fta',
  page: '',

  // Pagination.jsx
  prev_page: 'FÃ¶reg sida',
  next_page: 'NÃ¤sta sida',
  prev_5: 'FÃ¶reg 5 sidor',
  next_5: 'NÃ¤sta 5 sidor',
  prev_3: 'FÃ¶reg 3 sidor',
  next_3: 'NÃ¤sta 3 sidor'
};
